import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DetailDeviceHeader } from 'libs/portal/src/models/Device';
import { Sim } from 'libs/portal/src/models/Sim';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { ToastrService } from 'ngx-toastr';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserAccessRole, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { DeviceSimInfoComponent } from '../device-sim-info/device-sim-info.component';
import { MatDialog } from '@angular/material/dialog';
import { DeviceCapModalComponent } from '../device-cap-modal/device-cap-modal.component';
import { TimeAgoService } from '@huge-monorepo/hip/services';

@Component({
  selector: 'app-device-details-row-card',
  templateUrl: './device-details-row-card.component.html',
  styleUrls: ['./device-details-row-card.component.scss'],
})
export class DeviceDetailsRowCardComponent implements OnInit, OnChanges {
  @Input() data: DetailDeviceHeader;
  loading = true;

  onlineStatus = '';
  AccessObject: UserAccessRole | null;
  simFailoverAllowed = false;

  userHasWriteAccess: boolean = false;

  constructor(
    public tools: ToolsService,
    private db: GenericService,
    private toastService: ToastrService,
    private endpoints: Endpoints,
    private auth: UserRightsService,
    private dialog: MatDialog,
    private timeAgoService: TimeAgoService,
  ) { }

  ngOnInit() {
    this.AccessObject = this.auth.GetUserAccessRoles();
    if (!this.AccessObject) {
      return;
    }

    this.userHasWriteAccess = this.auth.GetUserPortalReadWrite().PortalWriteAccess;

    this.simFailoverAllowed = this.AccessObject.IsMikrotikAdmin();

    if (this.data.CdrOnline != null) {
      this.tools.CalculateDeviceStatus(this.data, 'LastUsage', 'ParsedLastCdrPing');
    }

    if (this.data['KAOnline'] != null) {
      this.tools.CalculateDeviceStatus(this.data, 'KALastPing', 'ParsedKALastPing');
    }

    if (this.data && this.data.SIMs != null && this.data.SIMs.length > 0) {
      for (let i = 0; i < this.data.SIMs.length; i++) {
        this.data.SIMs[i].Icon = '../../../../assets/img/' + this.tools.GetSimIconBasedOnNetworkName(this.data.SIMs[i].ServiceProvider);
      }
    }
    console.log(this.data);
    this.loading = false;
  }

  async presentPopover(sim: Sim, eve: any) {
    // Set the position relative to the button that triggers the dialog
    const buttonElement = eve.srcElement; // Replace 'your-button-id' with the actual ID of your button
    const rect = buttonElement.getBoundingClientRect();

    const dialogRef = this.dialog.open(DeviceSimInfoComponent, {
      position: {
        top: rect.bottom + 'px',
        left: (rect.left - 350) + 'px'
      },
      data: sim,
      hasBackdrop: true,
      width: "400px"
    });

    let dialogSub = dialogRef.afterClosed().subscribe({
      next: (simData) => {
        if (simData?.data != null) {
          let sims = [...this.data.SIMs];
          let index = 0;
          this.data.SIMs.forEach((sim, i) => {
            if (sim['SimID'] == simData.data['SimID']) {
              index = i;
            }
          });
          sims[index] = simData.data;
          this.data.SIMs = sims;
        }
        dialogSub.unsubscribe();
      },
    });
  }

  async presentCapConfigPopover() {
    const dialogRef = this.dialog.open(DeviceCapModalComponent, {
      data: {
        uniqueDeviceCap: this.data.CapSettings.CapType == "device",
        capValue: this.data.CapSettings.CapValue,
      },
      hasBackdrop: false
    });
    let dialogSub = dialogRef.afterClosed().subscribe({
      next: (data) => {
        if (data == null) return;
        let results: { uniqueDeviceCap: boolean, capValue: number, reason: string, monthlyCapping: boolean } = data.data;
        if (results == null) return;
        this.db.PUT(this.endpoints.UPDATE_DEVICE_CAP(this.data.DeviceID), {
          MonthlyCapping: results.monthlyCapping,
          FixedCapping: !results.monthlyCapping,
          CapValue: results.capValue,
          Active: results.uniqueDeviceCap,
          Reason: results.reason
        }).subscribe({
          next: (_) => {
            // this.toastService.success("Successfully updated device usage cap", 1000);
          }
        });
        dialogSub.unsubscribe();
      },
    });
  }

  initiateSimFailover() {
    if (!this.simFailoverAllowed) {
      return;
    }

    this.db.GET(this.endpoints.SIMFAILOVER(this.data.DeviceID)).subscribe((results) => {
      console.log(results);
      this.toastService.info('Please give approximately 10 minutes for the change to reflect', 'Sim Switch Requested.', { timeOut: 5000 });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.data = changes['data'].currentValue as DetailDeviceHeader;
    }

    if (changes['sims']) {
      this.data.SIMs = changes['sims'].currentValue as Sim[];
    }
  }

  timeAgo(time: string) {
    return this.timeAgoService.transform(time);
  }
}
